"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolGroupLinkStatus = void 0;
var SchoolGroupLinkStatus;
(function (SchoolGroupLinkStatus) {
    SchoolGroupLinkStatus["Pending"] = "pending";
    SchoolGroupLinkStatus["Active"] = "active";
    SchoolGroupLinkStatus["Disabled"] = "disabled";
})(SchoolGroupLinkStatus = exports.SchoolGroupLinkStatus || (exports.SchoolGroupLinkStatus = {}));
//# sourceMappingURL=SchoolGroupLink.js.map